import * as React from "react";
import {Instalment} from "@ferry/journey-services";
import {resourcesHelper} from "@ferry/portal-core";
import PaymentSchedule from "./PaymentSchedule";


interface IProps {
    interaction: any;
    paidAmount?: number | undefined;
    installmentSum?: number | undefined;
    totalAmount?: number | undefined;
    instalments: Instalment[] | undefined;
    isPaidOff?: boolean | false;
}

interface IState {
    isOpen: boolean;
    totalAmount: number;
    paidAmount: number;
    instalments: Instalment[];
}

export class PaymentScheduleSection extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false,
            totalAmount: this.props.totalAmount ? this.props.totalAmount : 0,
            paidAmount: this.props.paidAmount ? this.props.paidAmount : 0,
            instalments: this.props.instalments ? this.props.instalments : []
        };
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if(prevProps !== this.props) {
            this.setState({
                totalAmount: this.props.totalAmount ? this.props.totalAmount : 0,
                paidAmount: this.props.paidAmount ? this.props.paidAmount : 0,
                instalments: this.props.instalments ? this.props.instalments : []
            });
        }
    }

    public render() {
        return (
           <div className="payment-schedule-section">
               <div className="d-flex flex-row">
                   <div className="d-none d-md-flex flex-column">
                       <img className="icon-panel mb-0"
                            src={`/${resourcesHelper.THEME_PATH}/img/payment-calendar.svg`}
                            alt="Payment calendar icon" aria-label="Payment calendar icon"/>
                   </div>
                   <div className="d-flex flex-column justify-c-center w-100">
                       <div className="d-md-none d-flex align-i-center mb-3">
                           <img className="icon-panel mb-0"
                                src={`/${resourcesHelper.THEME_PATH}/img/payment-calendar.svg`}
                                alt="Payment calendar icon" aria-label="Payment calendar icon"/>
                           <h2 className="font-family-display font-weight-bold mb-0">
                               Payment schedule
                           </h2>
                       </div>
                       <div className="d-flex flex-column">
                           <h2 className="font-family-display font-weight-bold d-md-block d-none mb-4">
                               Payment schedule
                           </h2>
                           {this.props.isPaidOff ?
                               <div className="text-center">
                                   <p className="mb-0">
                                       You have paid off your balance
                                   </p>
                                   <p>
                                       (no instalments left)
                                   </p>
                               </div>
                               :
                               <div className="text-center">
                                   <p className="mb-0">
                                       {`You have paid ${this.state.paidAmount.toFixed(2)} out of ${this.props.totalAmount?.toFixed(2)}`}
                                   </p>
                                   <p>
                                       {`(${(this.state.instalments.length - this.getPaidInstalments())} instalments left X ${this.props.installmentSum?.toFixed(2)})`}
                                   </p>
                               </div>
                           }
                           <div className="mb-3">
                               <PaymentSchedule
                                   isOpen={this.state.isOpen}
                                   instalments={this.props.instalments || []}
                                   isPaidOff={this.props.isPaidOff || false}
                                   interaction={this.props.interaction}
                               />
                           </div>
                           <div>
                               <button
                                   className="payment-schedule-button btn btn-white-dashboard mb-0 mt-0"
                                   onClick={this.toggleInstallmentPlan}
                               >
                                   <span>{this.state?.isOpen ? 'Hide instalments plan' : 'View instalments plan'}</span>
                                   <i className={`fas ${this.state?.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'} glyph-margin`} />
                               </button>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
        )
    }

    private getPaidInstalments = () : number => {
        let paidInstalmentCount = 0;
        this.props.instalments?.forEach(instalment => {
            if (!instalment.amount || instalment.status === "PAID") {
                paidInstalmentCount ++;
            }
        })
        return paidInstalmentCount;
    }

    private toggleInstallmentPlan = () : void => {
        this.setState({
            isOpen: !this.state?.isOpen
        })
    }

}
